import React from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes, css } from 'styled-components';
import { color } from '../styles/helpers/variables';

export const LoadingSpinner = props => {
  const { margin } = props;
  return <LoadingSpinnerRoot margin={margin} />;
};

LoadingSpinner.defaultProps = {
  margin: undefined
};

LoadingSpinner.propTypes = {
  margin: PropTypes.string
};

const Spin = keyframes`
  to {
    transform: rotateZ(360deg);
  }
`;

const LoadingSpinnerRoot = styled.div`
  margin: 100px auto;
  width: 75px;
  height: 75px;
  border-radius: 100%;
  border: 3px solid ${color.grey};
  border-top-color: ${color.black};
  animation: ${Spin} 1s linear infinite;

  @media screen and (min-width: 768px) {
    margin: 200px auto;
  }

  ${props =>
    props.margin &&
    css`
      margin: ${props.margin};
    `};
`;



// WEBPACK FOOTER //
// ./src/components/LoadingSpinner.js